import { render, staticRenderFns } from "./PazientiProgettiViewPage.vue?vue&type=template&id=ef2b7826"
import script from "./PazientiProgettiViewPage.vue?vue&type=script&lang=js"
export * from "./PazientiProgettiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports